import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { authService } from "../services/auth.service";

const ForgotPassword: React.FC = () => {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault();
    setError("");
    setMessage("");
    setIsSubmitting(true);

    try {
      await authService.requestPasswordReset(email);
      setMessage(
        "If an account exists for that email, a reset link has been sent."
      );
    } catch (err: any) {
      setError(err.response?.data?.message || "Failed to request reset link");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div style={containerStyle}>
      <div style={formBoxStyle}>
        <div style={{ display: "flex", justifyContent: "center", marginBottom: "1.5rem" }}>
          <img
            src="https://eidosverse.com/assets/EidosGo.png"
            alt="EidosGo"
            style={{ width: "160px", height: "auto" }}
          />
        </div>
        <h2 style={{ marginTop: 0 }}>Forgot your password?</h2>
        <p style={{ marginBottom: "1.5rem", color: "#666" }}>
          Enter your email and we will send you a reset link.
        </p>
        <form onSubmit={handleSubmit} style={formStyle}>
          <div style={inputGroupStyle}>
            <label>Email</label>
            <input
              type="email"
              value={email}
              onChange={(event) => setEmail(event.target.value)}
              required
              style={inputStyle}
            />
          </div>

          {error && <div style={errorStyle}>{error}</div>}
          {message && <div style={messageStyle}>{message}</div>}

          <button type="submit" style={buttonStyle} disabled={isSubmitting}>
            {isSubmitting ? "Sending..." : "Send reset link"}
          </button>
        </form>

        <button
          type="button"
          onClick={() => navigate("/login")}
          style={linkButtonStyle}
        >
          Back to login
        </button>
      </div>
    </div>
  );
};

const containerStyle: React.CSSProperties = {
  minHeight: "100vh",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  background: "#ecf0f1",
};

const formBoxStyle: React.CSSProperties = {
  background: "white",
  padding: "2rem",
  borderRadius: "8px",
  boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
  width: "400px",
  maxWidth: "90%",
};

const formStyle: React.CSSProperties = {
  display: "flex",
  flexDirection: "column",
  gap: "1rem",
};

const inputGroupStyle: React.CSSProperties = {
  display: "flex",
  flexDirection: "column",
  gap: "0.5rem",
};

const inputStyle: React.CSSProperties = {
  padding: "0.75rem",
  border: "1px solid #ddd",
  borderRadius: "4px",
  fontSize: "1rem",
  width: "100%",
};

const buttonStyle: React.CSSProperties = {
  padding: "0.75rem",
  background: "#3498db",
  color: "white",
  border: "none",
  borderRadius: "4px",
  fontSize: "1rem",
  cursor: "pointer",
};

const linkButtonStyle: React.CSSProperties = {
  marginTop: "1.5rem",
  background: "none",
  border: "none",
  color: "#2c3e50",
  cursor: "pointer",
  textDecoration: "underline",
};

const errorStyle: React.CSSProperties = {
  color: "#e74c3c",
  fontSize: "0.9rem",
  padding: "0.5rem",
  background: "#ffe6e6",
  borderRadius: "4px",
};

const messageStyle: React.CSSProperties = {
  color: "#2c3e50",
  fontSize: "0.9rem",
  padding: "0.5rem",
  background: "#e8f4fd",
  borderRadius: "4px",
};

export default ForgotPassword;
